import { autenticado, getUserDataCookie } from '../../services/auth'
import { API_KEY_LINX } from '../config'

const useLinxMeta = () => {
  const hasWindow = typeof window !== 'undefined'

  function removeLinxUser() {
    delete window.linxMeta?.user
  }

  function setLinxUser() {
    if (autenticado()) {
      const userData = getUserDataCookie()

      window.linxMeta = {
        ...window.linxMeta,
        user: {
          id: userData.id_consumidor,
          name: userData.user_name,
          email: userData.email,
          allowMailMarketing: userData.email_publicidade,
        },
      }
    }
  }

  function setLinxItems(items) {
    const productsLinx = items.map((item) => ({
      pid: item.id,
      price: item.price,
      ...(item?.collectInfo?.skuList[0]
        ? { sku: item.collectInfo.skuList[0] }
        : {}),
    }))
    window.linxMeta = {
      ...window.linxMeta,
      items: productsLinx,
      page: 'search',
    }
  }

  function setEmptySearch() {
    delete window.linxMeta?.items

    window.linxMeta = {
      ...window.linxMeta,
      page: 'emptysearch',
    }
  }

  function setLinxSearch(items, searchId, searchQuery) {
    window.linxMeta = {
      ...window.linxMeta,
      searchId: searchId,
      ...(searchQuery ? { query: searchQuery } : {}),
    }

    if (!items?.length) {
      setEmptySearch()
    } else {
      setLinxItems(items)
    }

    window.linxImpulse?.createEvent('linximpulse.navigation')
  }

  function removeLinxSearch() {
    delete window.linxMeta?.searchId
    delete window.linxMeta?.query
    delete window.linxMeta?.items
  }

  function makeLinxCategory(id, name, parents = []) {
    parents = parents.filter((parent) => parent)
    return {
      id,
      name,
      ...(parents.length > 0 ? { parents } : {}),
    }
  }

  function setLinxCategory(category, searchId) {
    window.linxMeta = {
      ...window.linxMeta,
      searchId: searchId,
      page: 'category',
      categories: [makeLinxCategory(category.slug, category.nome)],
    }
  }

  function getParentCategories(subcategory) {
    let parents = []
    let currentCategory = subcategory.categoria_pai[0]

    while (currentCategory) {
      parents.push(currentCategory.slug)
      currentCategory =
        currentCategory?.categoria_pai?.length > 0
          ? currentCategory.categoria_pai[0]
          : null
    }

    return parents.reverse()
  }

  function setLinxSubCategory(subcategory, searchId) {
    const parents = getParentCategories(subcategory)

    window.linxMeta = {
      ...window.linxMeta,
      searchId: searchId,
      page: 'subcategory',
      categories: [
        makeLinxCategory(subcategory.slug, subcategory.nome, parents),
      ],
    }
  }

  function removeLinxCategory() {
    delete window.linxMeta?.searchId
    delete window.linxMeta?.categories
  }

  function initLinxMeta() {
    if (hasWindow && !window.linxMeta) {
      window.linxMeta = { page: 'home' }
      setLinxUser()
    }
  }

  function removeLinxMetaDataByUrl(url) {
    const removalMethodsMappings = {
      ['/busca']: removeLinxSearch,
      ['/categoria']: removeLinxCategory,
    }
    const pathsWithLinxData = Object.keys(removalMethodsMappings)

    pathsWithLinxData.map(
      (path) => !url.startsWith(path) && removalMethodsMappings[path]()
    )
  }

  function isUrlWithoutLinxMetaData(url) {
    const pathsWithLinxData = ['/busca', '/categoria']
    return !pathsWithLinxData.some((path) => url.startsWith(path))
  }

  function setLinxHome() {
    window.linxMeta = { ...window.linxMeta, page: 'home' }
  }

  function routeChangeLinx(url) {
    removeLinxMetaDataByUrl(url)
    isUrlWithoutLinxMetaData(url) && setLinxHome()
  }

  function makeLinxClickEventMetaData(
    trackingId,
    deviceId,
    source,
    interactionType
  ) {
    return {
      apikey: API_KEY_LINX,
      trackingId,
      deviceId,
      source,
      interactionType,
      ...(window.linxMeta?.user?.id ? { userId: window.linxMeta.user.id } : {}),
    }
  }

  function makeLinxClickEventUrl(metadata, baseUrl = null) {
    if (!baseUrl)
      baseUrl = `https://api.linximpulse.com/engage/search/v3/clicks`

    let queryStringTokens = []
    for (let key in metadata) queryStringTokens.push(`${key}=${metadata[key]}`)

    return `${baseUrl}?${queryStringTokens.join('&')}`
  }

  async function requestLinxClickEvent(metadata, baseUrl = null) {
    const url = makeLinxClickEventUrl(metadata, baseUrl)
    const options = { method: 'GET', headers: { accept: 'application/json' } }

    return await fetch(url, options)
  }

  async function triggerLinxProductViewClickEvent(inputData, baseUrl) {
    const interactionType = 'PRODUCT_VIEW'
    const metadata = makeLinxClickEventMetaData(
      inputData.trackingId,
      inputData.deviceId,
      inputData.source,
      interactionType
    )

    return await requestLinxClickEvent(metadata, baseUrl).catch((err) =>
      console.error('error:' + err)
    )
  }

  async function triggerLinxAddToCartClickEvent(inputData, baseUrl) {
    const interactionType = 'ADD_TO_CART'
    const metadata = makeLinxClickEventMetaData(
      inputData.trackingId,
      inputData.deviceId,
      inputData.source,
      interactionType
    )

    return requestLinxClickEvent(metadata, baseUrl).catch((err) =>
      console.error('error:' + err)
    )
  }

  const makeLinxClickEventInputData = (trackingId, deviceId, source) => ({
    trackingId,
    deviceId,
    source,
  })

  return {
    initLinxMeta,
    setLinxUser,
    removeLinxUser,
    setLinxSearch,
    setLinxCategory,
    setLinxSubCategory,
    routeChangeLinx,
    triggerLinxAddToCartClickEvent,
    triggerLinxProductViewClickEvent,
    makeLinxClickEventInputData,
  }
}

export default useLinxMeta
